// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"236b0c57","126":"69c0f041","507":"8366ea55","787":"cc2264ea","885":"c9c9c623"}[chunkId] + ".chunk.js";
};